<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="存储类型">
                <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in typeStatus"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="存储费类型">
                <a-select placeholder="请选择" v-model="queryParam.renewType" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in renewType"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="生效状态">
                <a-select placeholder="请选择" v-model="queryParam.effectiveStatus" style="width: 100%" allow-clear>
                  <a-select-option :key="item.id" v-for="item in effectiveStatus"> {{ item.name }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 禁用 </a-select-option>
                  <a-select-option :value="1"> 有效 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        :scroll="{ x: 1160, y: 960 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false">
        <span slot="renewType" slot-scope="text, record">
          <span>{{ record.renewType | formStatus(renewType) }}</span>
        </span>
        <span slot="expireStatus" slot-scope="text, record">
          <span>{{ record.expireStatus | formStatus(expireStatus) }}</span>
        </span>
        <span slot="effectiveStatus" slot-scope="text, record">
          <span>{{ record.effectiveStatus | formStatus(effectiveStatus) }}</span>
        </span>
        <span slot="type" slot-scope="text, record">
          <span>{{ record.type | formStatus(typeStatus) }}</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status == 0">有效</span>
          <span v-if="record.status == 1">禁用</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="$refs.vrForm.handleUpdate(record, undefined)"
            v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']">
            编辑
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
    <createForm ref="vrForm" @getList="getList"></createForm>
  </page-header-wrapper>
</template>
<script>
import { fetchList } from '@/api/VR/tenantStorage/index'
import createForm from './model/createForm'
import parameter from '@/mixins/parameter'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
export default {
  components: { createForm },
  mixins: [tableMixin, parameter],

  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        overflowType: undefined,
        status: undefined,
      },
      loading: false,
      tableSize: 'default',
      list: [],
      total: 0,
      value: [],
      selectedRowKeys: [],
        // 高级搜索 展开/关闭
      advanced: false,
      columns: [
        // {
        //   title: '单位标识',
        //   dataIndex: 'tenantId',
        // },
        // {
        //   title: '套餐名称',
        //   width: '100px',
        //   fixed: 'left',
        //   dataIndex: 'packageName',
        // },
        {
          title: '已使用(MB)',
          width: '110px',
          dataIndex: 'usedCapacity',
        },
        {
          title: '总已使用(MB)',
          width: '120px',
          dataIndex: 'totalUsedCapacity',
        },
        {
          title: '总容量(MB)',
          width: '110px',
          dataIndex: 'sumAllocateCapacity',
        },
        {
          title: '分配总(MB)',
          width: '110px',
          dataIndex: 'usedCapacity',
        },
        {
          title: '分配已使用(MB)',
          width: '130px',
          dataIndex: 'sumUsedCapacity	',
        },
        {
          title: '冻结容量(MB)',
          width: '120px',
          dataIndex: 'sharedFrozenCapacity',
        },
        // {
        //   title: '存储费类型',
        //   dataIndex: 'renewType',
        //   width: '100px',
        //   scopedSlots: { customRender: 'renewType' },
        // },
        {
          title: '存储类型',
          dataIndex: 'type',
          width: '90px',
          scopedSlots: { customRender: 'type' },
        },
        // {
        //   title: '生效状态',
        //   width: '90px',
        //   dataIndex: 'effectiveStatus',
        //   scopedSlots: { customRender: 'effectiveStatus' },
        // },
        // {
        //   title: '状态',
        //   width: '70px',
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        // },
        // {
        //   title: '激活时间',
        //   width: '110px',
        //   dataIndex: 'activationTime',
        // },
        // {
        //   title: '到期时间',
        //   width: '110px',
        //   dataIndex: 'expireTime',
        // },
        {
          title: '最后统计',
          width: '110px',
          dataIndex: 'lastStatDate',
        },
        {
          title: '创建时间',
          width: '110px',
          // fixed: 'right',
          dataIndex: 'createTime',
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.loading = false
        this.list = res.data.records
        this.total = res.data.total
      })
    },
      toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.getList()
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    resetQuery() {
      this.valu = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        overflowType: undefined,
        status: undefined,
      }
      this.getList()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/storage/tenant/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
  mounted() {
    this.getList()
  },
}
</script>
<style lang="scss" scoped></style>
